// Action Types
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_ATHLETE_PROFILE = "UPDATE_ATHLETE_PROFILE";
export const SELECT_PAYMENT_PLAN = "SELECT_PAYMENT_PLAN";
export const UPDATE_COMPANY_INFO = "UPDATE_COMPANY_INFO";
export const SET_UNREAD_NOTIFICATION_COUNT = "SET_UNREAD_NOTIFICATION_COUNT";

export const selectPaymentPlan = (plan) => ({
  type: SELECT_PAYMENT_PLAN,
  payload: plan,
});

// Action Creators
export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const logout = () => {
  return { type: LOGOUT };
};

export const updateProfile = (profileData) => ({
  type: UPDATE_PROFILE,
  payload: profileData,
});
export const updateAthleteProfile = (athleteProfileData) => ({
  type: UPDATE_ATHLETE_PROFILE,
  payload: athleteProfileData,
});

export const updateCompanyInfo = (companyData) => ({
  type: UPDATE_COMPANY_INFO,
  payload: companyData,
});

export const setUnreadNotificationCount = (count) => ({
  type: SET_UNREAD_NOTIFICATION_COUNT,
  payload: count,
});